import { ReactNode, useState } from 'react';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { FirebaseStoreInitializer } from '@/components/FirebaseStoreInitializer';

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <FirebaseStoreInitializer>{children}</FirebaseStoreInitializer>
    </QueryClientProvider>
  );
}
